import {
  evolve, compose,
  lensPath, set, pathOr
} from 'ramda';

import { successEvolve, requestEvolve, failEvolve } from './reducerUtill';

export const worktimeTypesActions = {
  request: 'WORKTIME_TYPES_REQUEST',
  success: 'WORKTIME_TYPES_SUCCESS',
  fail: 'WORKTIME_TYPES_FAIL',
  optionsSuccess: 'WORKTIME_TYPES_OPTIONS_SUCCESS'
};

export const worktimeTypeActions = {
  submit: 'WORKTIME_TYPE_SUBMIT',
  delete: 'WORKTIME_TYPE_DELETE'
};

export const workDayEventTypesActions = {
  request: 'WORK_DAY_EVENT_TYPES_REQUEST',
  success: 'WORK_DAY_EVENT_TYPES_SUCCESS'
};

export const requestWorktimeTypes = () => ({
  type: worktimeTypesActions.request
});

export const submitWorktimeType = (worktimeType) => ({
  type: worktimeTypeActions.submit,
  payload: worktimeType
});

export const deleteWorktimeType = (id) => ({
  type: worktimeTypeActions.delete,
  payload: id
});

const toOptions = (list) => list.map(({ Id, Name }) => ({ label: Name, value: `${Id}` }));

const initialState = {
  list: {},
  options: [],
  eventTypes: [],
  pending: false,
  errors: []
};

const rootSelector = (state) => pathOr({}, ['worktimeTypes'], state);

export const selectWorktimeTypesData = compose(
  pathOr({}, ['list']),
  rootSelector
);

const worktimeTypesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case worktimeTypesActions.request: {
      return evolve(requestEvolve, state);
    }
    case worktimeTypesActions.fail: {
      return evolve(failEvolve(payload), state);
    }
    case worktimeTypesActions.success: {
      return compose(
        evolve(successEvolve),
        set(lensPath(['list']), payload)
      )(state);
    }
    case worktimeTypesActions.optionsSuccess: {
      return {
        ...state,
        options: toOptions(payload)
      };
    }
    case workDayEventTypesActions.success: {
      return {
        ...state,
        eventTypes: payload
      };
    }
    default: {
      return state;
    }
  }
};

export default worktimeTypesReducer;
